import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import PrimaryButton from "../PrimaryButton";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../styles.css";

// import required modules
import { Navigation, Pagination } from "swiper/modules";

const HeaderSwiper = () => {
  return (
    <div dir="ltr">
      <Swiper
        autoHeight={true}
        spaceBetween={20}
        navigation={true}
        pagination={{
          clickable: true,
        }}
        modules={[Navigation, Pagination]}
        className="mySwiper relative !z-0"
      >
        {/* <SwiperSlide>
          <img src="images/first_slide.jpg" alt="first slide" />
        </SwiperSlide> */}
        {/* <SwiperSlide>
          <img src="images/second_slide.jpg" alt="second slide" />
        </SwiperSlide> */}
        {/* <SwiperSlide>
          <img src="images/third_slide.jpg" alt="third slide" />
          <article className="bg-primary pt-8 pb-16 px-4 text-base flex items-center justify-center flex-col">
            <p>تستطيع معرفة حساباتنا البنكية من هنا</p>
            <div className="mt-8">
              <PrimaryButton
                content={"الحسابات البنكية"}
                link={""}
                className={"bg-secondary shadow-md rounded-md"}
              ></PrimaryButton>
            </div>
          </article>
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <img src="images/fourth_slide.jpg" alt="fourth slide" />
        </SwiperSlide> */}
        <SwiperSlide>
          <img
            src="images/eleven_slide.png"
            alt="King salman bin Abdulaziz Al Saud"
            className="w-full aspect-auto"
          />
        </SwiperSlide>
        {/* <SwiperSlide>
          {" "}
          <img src="images/fourth_slide.jpg" alt="fourth slide" />
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <img src="images/fifth_slide.jpeg" alt="fifth slide" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="images/six_slide.jpg" alt="sixth slide" />
          <article className="bg-primary pt-8 pb-16 px-4 text-base flex items-center justify-center flex-col">
            <p>بركة الدار</p>
            <div className="mt-8">
              <PrimaryButton content={"بركة دار"} link={""}></PrimaryButton>
            </div>
          </article>
        </SwiperSlide>
        <SwiperSlide>
          <img src="images/seventh_slide.png" alt="seventh slide" />
          <article className="bg-primary pt-8 pb-16 px-4 text-base flex items-center justify-center flex-col">
            <p className="text-base">
              سجل .. لتوريد الخدمات وكن شريكاً لنجاحنا
            </p>
          </article>
        </SwiperSlide>
        <SwiperSlide>
          <img src="images/eighth_slide.png" alt="eigth slide" />
          <article className="bg-primary pt-8 pb-16 px-4 text-base flex items-center justify-center flex-col">
            <p className="text-base">موقع سعادة اونلاين </p>
          </article>
        </SwiperSlide>
        <SwiperSlide>
          <img src="images/nineth_slide.png" alt="nineth slide" />
          <article
            dir="rtl"
            className="bg-primary pt-8 pb-16 px-4 text-base flex items-center justify-center flex-col"
          >
            <div className="max-w-md">
              <div className="flex flex-wrap gap-2" dir="ltr">
                <div className="bg-white rounded-md text-center py-2 relative w-full">
                  <div className="relative z-10">
                    تم التبرع بـ
                    <span> 117,146</span>
                    ريال من
                    <span> 210,000</span>
                  </div>
                  <div className="absolute top-0 left-0 h-full bg-green-600 w-3/5 z-0"></div>
                </div>
                <div
                  className="bg-white rounded-md text-center p-2"
                  dataamount={200}
                  dir="rtl"
                >
                  200 ريال
                </div>
                <div
                  className="bg-white rounded-md text-center p-2"
                  dataamount={50}
                  dir="rtl"
                >
                  لا تحقر القليل من الصدقة ( 50 ريال )
                </div>
                <div
                  className="bg-white rounded-md text-center p-2"
                  dataamount={300}
                  dir="rtl"
                >
                  300 ريال
                </div>
                <div
                  className="bg-white rounded-md text-center p-2"
                  dataamount={500}
                  dir="rtl"
                >
                  500 ريال
                </div>
              </div>
              <div className="relative mt-2">
                <input
                  type="number"
                  name="amount"
                  maxLength={6}
                  step={0.01}
                  placeholder="مبلغ التبرع"
                  min={50}
                  max={92854}
                  className="w-full bg-white rounded-md p-2 outline-none text-sm"
                />
                <i className="absolute top-1/2 -translate-y-1/2 left-2 text-slate-400">
                  ر.س.
                </i>
              </div>
              <div className="flex gap-4 w-full mt-2">
                <PrimaryButton
                  content={""}
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  }
                  link={""}
                  className={"bg-secondary shadow-md rounded-md"}
                ></PrimaryButton>
                <PrimaryButton
                  content={"تبرع الآن"}
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  }
                  link={""}
                  className={"bg-green-600 shadow-md rounded-md flex-1"}
                ></PrimaryButton>
              </div>
            </div>
          </article>
        </SwiperSlide>
        <SwiperSlide>
          <img src="images/tenth_slide.jpg" alt="tenth slide" />
          <article className="bg-primary pt-8 pb-16 px-4 text-base flex items-center justify-center flex-col">
            <p className="text-sm text-center">
              (مانقص مال من صدقة ) <br /> <br />
              الرسول الأكرم صلى الله عليه وآله وسلم{" "}
            </p>
          </article>
        </SwiperSlide> */}
      </Swiper>
    </div>
  );
};

export default HeaderSwiper;
